/**
 * NCB 功能介绍系列文章数据
 * 12篇静态内容，无需API加载
 */

export const GUIDE_ARTICLES = [
  {
    id: 1,
    slug: 'what-is-ncb',
    icon: '🚀',
    title: 'NCB 是什么？零代码建站的全新方式',
    subtitle: '为什么需要 NCB？它能解决什么问题？',
    readTime: '5 分钟',
    content: `
      <h2>引言：一个用功能代替代码的故事</h2>
      <p>每一个产品经理都经历过这样的困境：你有一个完整的产品构想，你清楚地知道用户需要什么、页面应该长什么样、数据应该怎么流转。但是，你需要一个开发团队来实现它。</p>
      <p>找开发团队意味着什么？意味着沟通成本、排期等待、需求变形、反复修改。一个你脑子里已经想清楚的网站，从提需求到上线可能要三个月——其中真正写代码的时间可能只有两周，剩下的时间都花在了「沟通」上。</p>
      <p><strong>NCB（No Code Builder）的诞生，就是为了消除这个鸿沟。</strong></p>

      <h2>NCB 能做什么？</h2>
      <p>一句话概括：<strong>NCB 让你在不写一行代码的情况下，独立完成一个功能完整的网站的全生命周期——从设计、开发、测试到上线运营。</strong></p>
      <p><strong>页面设计</strong> — 可视化拖拽编辑器，同时支持 PC 端和移动端页面设计。你在画布上拖放文字、图片、按钮、表单等区块，所见即所得。</p>
      <p><strong>数据管理</strong> — 内置完整的表单与数据系统。数据采集表单、数据关联关系、自动计算公式——这些在传统开发中需要后端工程师花几天写的功能，在 NCB 中只需要鼠标点击配置。</p>
      <p><strong>用户系统</strong> — 网站访问者可以注册、登录，不同角色配置不同的页面权限和数据权限。</p>
      <p><strong>移动端适配</strong> — 专门的移动端设计器，支持拍照上传、地理定位、下拉刷新、分享等手机原生能力。</p>
      <p><strong>内容管理</strong> — 内置 CMS 系统，支持富文本文章编辑、预览、上架/下架管理。</p>
      <p><strong>在线支付</strong> — 集成支付功能，支持用户在网站内完成付款操作。</p>

      <h2>NCB 与其他建站工具的根本区别</h2>
      <p><strong>模板类建站（WordPress、Wix）</strong> — 给你漂亮的模板，但模板就是天花板。业务需要数据级联、审批流程、自动统计时，模板帮不了你。</p>
      <p><strong>重前端设计类（Webflow）</strong> — 页面设计自由度高，但数据能力几乎为零。做展示页没问题，做业务系统不行。</p>
      <p><strong>低代码/表单类（简道云、轻流）</strong> — 后端数据管理能力不错，但前端页面呆板，无法自由设计布局。</p>
      <p><strong>NCB 的定位完全不同：前端自由设计 + 后端复杂数据逻辑，两端都不妥协。</strong></p>

      <h2>谁适合使用 NCB？</h2>
      <p><strong>产品经理</strong>：把 PRD 直接变成可运行的网站<br/>
      <strong>创业者</strong>：快速验证业务想法，1~4 周从零到上线<br/>
      <strong>运营人员</strong>：独立搭建活动页面、数据采集表单<br/>
      <strong>小微企业</strong>：无需雇佣技术团队，自己搭建企业官网、客户管理系统</p>
    `
  },
  {
    id: 2,
    slug: '5-minutes-first-site',
    icon: '⚡',
    title: '5分钟创建你的第一个网站',
    subtitle: '从注册到上线的最短路径',
    readTime: '4 分钟',
    content: `
      <h2>从零到上线，只需要一杯咖啡的时间</h2>
      <p>在 NCB 上，建站过程被压缩到了 5 分钟。这篇文章带你走一遍完整流程。</p>

      <h2>第一步：注册与登录</h2>
      <p>访问 <strong>www.noconb.com</strong>，点击右上角「个人中心」注册。填写邮箱，输入验证码，设置密码，30 秒完成。</p>

      <h2>第二步：创建项目</h2>
      <p>登录后进入个人中心，点击「创建新项目」，填写项目名称和描述。每个项目就是一个独立的网站。</p>

      <h2>第三步：进入租户工作台</h2>
      <p>点击项目进入「租户工作台」，左侧导航包含：页面管理、表单管理、字段管理、模板中心。</p>

      <h2>第四步：设计第一个页面</h2>
      <p>进入页面设计器，在空白画布上：添加区域 → 添加文字区块写标题 → 添加图片区块放 Logo → 添加按钮写「联系我们」。</p>

      <h2>第五步：预览效果</h2>
      <p>点击「预览」按钮，完整模拟用户访问效果。NCB 的核心原则：<strong>预览 = 运行时</strong>，预览效果就是最终效果。</p>

      <h2>第六步：发布上线</h2>
      <p>点击「发布」，系统生成访问链接。把链接分享给任何人，他们就能看到你的网站了。</p>
    `
  },
  {
    id: 3,
    slug: 'drag-and-design',
    icon: '🎨',
    title: '拖拽式页面设计：像搭积木一样建网站',
    subtitle: '设计器详解、区块类型、双端设计',
    readTime: '6 分钟',
    content: `
      <h2>所见即所得，不只是口号</h2>
      <p>NCB 的设计器从架构层面保证：设计器、预览页和运行时共用同一套渲染引擎。画布上的每一个像素，就是用户最终看到的每一个像素。</p>

      <h2>七种区块，满足所有需求</h2>
      <p><strong>文字区块</strong> — 标题、段落、说明文字，支持富文本编辑。</p>
      <p><strong>图片区块</strong> — 上传图片，支持适应模式、焦点、翻转和滤镜效果。</p>
      <p><strong>按钮区块</strong> — 5 种形状（面包型、键盘型、礼盒型、标签型、圆形），搭配纯色/渐变/立体效果，近乎无限的样式组合。</p>
      <p><strong>交互区块</strong> — 连接表单系统，让用户在页面上直接填写和提交数据。</p>
      <p><strong>卡片区块</strong> — 数据列表展示，支持横向滑动和纵向排列。</p>
      <p><strong>详情区块</strong> — 展示单条数据的详细信息。</p>
      <p><strong>视频区块</strong> — 嵌入视频内容。</p>

      <h2>PC 端与移动端：独立设计</h2>
      <p>NCB 为 PC 端（1280×800 画布）和移动端（375px 手机壳画布）提供独立设计器，共用同一套表单和字段系统。</p>

      <h2>十种点击行为</h2>
      <p>跳转页面、跳转链接、复制内容、分享页面、扫描二维码、启动流程、打开弹窗、发起支付、震动反馈、全屏切换——全在下拉菜单中配置。</p>

      <h2>模板系统</h2>
      <p>区块模板（样式模板/完整模板）、页面模板、NCB 公共模板库——设计一次，复用无限次。</p>
    `
  },
  {
    id: 4,
    slug: 'forms-and-data',
    icon: '📊',
    title: '表单与数据：让网站「活」起来',
    subtitle: '字段体系、数据联动、公式计算',
    readTime: '6 分钟',
    content: `
      <h2>数据驱动才是核心</h2>
      <p>纯展示网站任何工具都能做。但用户填报名表、产品列表随数据更新、选项级联变化——这就是数据驱动。NCB 从设计之初就把数据管理作为核心。</p>

      <h2>丰富的字段类型</h2>
      <p>字符串、长文本、整数、浮点数、日期、时间、逻辑、富文本、图片、文件、邮箱、电话、链接、密码——覆盖所有数据场景。</p>

      <h2>三种表单类型</h2>
      <p><strong>基础表单</strong> — 数据采集，如「客户信息表」。</p>
      <p><strong>属性表</strong> — 枚举值维护，如「省市区表」。</p>
      <p><strong>检索子表</strong> — 条件筛选 + 数据录入的分步操作。</p>

      <h2>属性级联：智能联动</h2>
      <p>产品类别 → 产品系列 → 具体型号，每级选项取决于上级选择。传统开发需要大量联动代码，NCB 中只需设置字段级联层级即可。</p>

      <h2>43 函数公式引擎</h2>
      <p>数学（SUM、AVG、ROUND）、文本（CONCAT、LEFT、REPLACE）、日期（DATEDIFF、DATEADD）、逻辑（IF、AND、SWITCH）、统计（COUNT、SUMIF）、跨期（PREV）——全部通过可视化编辑器配置。</p>

      <h2>数据展示</h2>
      <p>卡片模式（横向滑动/纵向列表）、详情页、表格模式——数据展示与采集都通过区块实现。</p>
    `
  },
  {
    id: 5,
    slug: 'users-and-permissions',
    icon: '🔐',
    title: '用户系统与权限：谁能看什么、做什么',
    subtitle: '注册登录、角色管理、访问控制',
    readTime: '5 分钟',
    content: `
      <h2>为什么需要用户系统？</h2>
      <p>员工需要登录才能访问内部系统，报名者需要注册才能提交信息，不同等级的会员看到不同内容——这些都需要用户系统。NCB 把注册登录、权限验证全部封装好了。</p>

      <h2>注册与登录</h2>
      <p><strong>邮箱注册</strong> — 验证码自动发送、有效期验证，全自动处理。</p>
      <p><strong>JWT 认证</strong> — 安全高效的登录状态管理。</p>
      <p><strong>防刷保护</strong> — 验证码保护 + 频率限制。</p>
      <p><strong>即将支持</strong>：短信验证码（腾讯云 SMS）、第三方登录（微信/QQ/支付宝）——配置渠道即可，系统自动处理授权回调。</p>

      <h2>角色管理</h2>
      <p>每个角色拥有独立的页面集合、导航栏和数据权限。例如培训网站：学员只看课程和个人中心，讲师可管理课程和学员，管理员访问全部页面。</p>

      <h2>页面级访问控制</h2>
      <p>「需要登录」「仅管理员」——一个复选框搞定。用户提交的数据自动关联身份，数据隔离开箱即用。</p>
    `
  },
  {
    id: 6,
    slug: 'mobile-h5',
    icon: '📱',
    title: '移动端 H5：手机上的完整体验',
    subtitle: '独立设计器、原生能力、PWA 离线',
    readTime: '5 分钟',
    content: `
      <h2>不是「缩小版」，是「手机版」</h2>
      <p>NCB 为移动端提供独立设计器，PC 和手机页面是两套独立设计，共用同一套数据系统。</p>

      <h2>移动端设计器</h2>
      <p><strong>手机壳预览</strong> — 375px 画布在逼真手机壳中设计，直观感受真实效果。</p>
      <p><strong>vw 适配</strong> — 自动转换为视口宽度百分比，适配不同手机。</p>
      <p><strong>导航布局</strong> — 底部固定 Tab 或左侧抽屉菜单。</p>
      <p><strong>屏幕固定</strong> — 任何区块可固定在屏幕顶部/底部。</p>

      <h2>手机原生能力</h2>
      <p><strong>拍照上传</strong> — 图片字段自动启用摄像头，客户端压缩（长边≤1200px）。</p>
      <p><strong>地理定位</strong> — GPS 获取经纬度，一键填入表单。</p>
      <p><strong>分享</strong> — 调用系统分享面板或复制链接。</p>
      <p><strong>扫码</strong> — 后置摄像头实时识别二维码。</p>
      <p><strong>下拉刷新</strong> — 与原生 App 一致的交互体验。</p>

      <h2>PWA 离线化</h2>
      <p>添加到桌面 → 全屏打开 → 离线访问。自动启用，无需额外配置。</p>
    `
  },
  {
    id: 7,
    slug: 'content-management',
    icon: '📝',
    title: '内容管理：像公众号一样发文章',
    subtitle: 'CMS 文章编辑、预览、上架管理',
    readTime: '4 分钟',
    content: `
      <h2>网站不只是功能，还有内容</h2>
      <p>公司新闻、行业动态、产品更新——这些内容需要经常更新。NCB 内置完整的内容管理功能。</p>

      <h2>CMS 页面管理</h2>
      <p>「关于我们」「联系我们」等固定页面：富文本编辑 → 新窗口预览前台效果 → 上架/下架。确保不会误发未完成内容。</p>

      <h2>新闻文章管理</h2>
      <p>创建文章（标题、摘要、分类、正文）→ 自动生成 SEO 友好 URL → 预览前台页面 → 发布。</p>
      <p>文章分类管理：公司新闻、行业动态、产品更新……前台按分类展示列表。</p>

      <h2>前台展示</h2>
      <p>固定页面通过导航栏访问，新闻列表按时间倒序排列，文章详情页完整展示内容。</p>

      <h2>未来：租户站内容管理</h2>
      <p>CMS 能力将开放给租户站，让你用 NCB 构建的网站的用户也能发布和管理文章。</p>
    `
  },
  {
    id: 8,
    slug: 'publish-and-deploy',
    icon: '🌐',
    title: '从设计到上线：发布、域名与运维',
    subtitle: '发布流程、数据安全、持续迭代',
    readTime: '5 分钟',
    content: `
      <h2>三阶段工作流</h2>
      <p><strong>设计阶段</strong> — 自由创作，线上用户看不到修改。</p>
      <p><strong>预览阶段</strong> — 与线上完全相同的渲染引擎。</p>
      <p><strong>发布阶段</strong> — 设计数据同步到运行时，1~2 秒完成。</p>

      <h2>数据安全</h2>
      <p><strong>多租户隔离</strong> — 数据库层面强制隔离。</p>
      <p><strong>HTTPS 加密</strong> — 所有传输加密。</p>
      <p><strong>XSS/SQL 防护</strong> — 智能安全中间件过滤恶意输入。</p>
      <p><strong>频率限制</strong> — API 请求频率限制，防刷攻击。</p>

      <h2>持续迭代</h2>
      <p>上线后随时回到设计器修改 → 预览 → 重新发布，所有改动遵循安全流程。</p>
    `
  },
  {
    id: 9,
    slug: 'data-and-workflow',
    icon: '⚙️',
    title: '数据流程与业务流程：让网站自己「跑」起来',
    subtitle: '数据自动流转、审批流程、流程监控',
    readTime: '6 分钟',
    content: `
      <h2>数据要会「流动」</h2>
      <p>数据采集只是第一步。请假申请需要三级审批，订单需要状态流转，销售线索需要自动分配——这些都是数据流转。</p>

      <h2>自定义数据流程</h2>
      <p>当 A 表发生事件，自动对 B 表执行操作。</p>
      <p><strong>场景一</strong>：订单金额超过 1000 元 → 自动复制到「大额订单表」+ 通知管理员。</p>
      <p><strong>场景二</strong>：用户下单 → 「商品库存表」自动扣减库存。</p>
      <p><strong>场景三</strong>：门店录入销售 → 自动汇总到「总部汇总表」。</p>

      <h2>自定义业务流程</h2>
      <p>多节点审批、条件分支、并行处理。采购审批示例：</p>
      <p>员工提交 → 金额判断（≤5000 部门主管审批 / >5000 加财务总监审批）→ 自动生成执行记录。</p>

      <h2>两者的区别</h2>
      <p><strong>数据流程</strong>：系统自动执行，处理数据同步/计算/汇总。</p>
      <p><strong>业务流程</strong>：需要人参与决策，处理审批/协作任务。实际项目中两者经常配合使用。</p>
    `
  },
  {
    id: 10,
    slug: 'analytics-and-toolbox',
    icon: '🧰',
    title: '统计分析与工具箱：产品经理的完备武器库',
    subtitle: '自定义统计、函数库、样式库、全景工具箱',
    readTime: '7 分钟',
    content: `
      <h2>自定义统计分析</h2>
      <p>选择数据源 → 配置维度与指标 → 设置过滤条件 → 选择图表类型 → 嵌入到任意页面。</p>
      <p>示例「HR 仪表板」：数据卡片（在职人数）+ 饼图（部门分布）+ 柱状图（入离职趋势）+ 表格（新员工明细）。</p>

      <h2>43 函数公式库</h2>
      <p><strong>数学</strong>：SUM、AVG、MAX、ROUND、SQRT……</p>
      <p><strong>文本</strong>：CONCAT、LEFT、REPLACE、TRIM……</p>
      <p><strong>日期</strong>：TODAY、DATEDIFF、DATEADD……</p>
      <p><strong>逻辑</strong>：IF、AND、OR、SWITCH……</p>
      <p><strong>统计</strong>：COUNT、COUNTIF、SUMIF、RANK……</p>
      <p><strong>跨期</strong>：PREV（引用前条记录值）——NCB 独有。</p>

      <h2>丰富的前端样式库</h2>
      <p>按钮：5形状 × 3配色 × 3效果 = 45+ 组合。区块模板库持续积累。移动端专属样式：固定导航、抽屉菜单、浮层。</p>

      <h2>产品经理的完备工具箱</h2>
      <p>页面设计器、移动设计器、表单系统、级联配置、公式引擎、数据流程、业务流程、统计分析、用户权限、内容管理、支付结算、PWA——12 项能力，替代传统的 UI 设计师 + 前端 + 后端 + DBA + 运维。</p>
      <p><strong>1 个产品经理，1~4 周。</strong></p>
    `
  },
  {
    id: 11,
    slug: 'payment',
    icon: '💰',
    title: '支付结算：让网站具备商业闭环能力',
    subtitle: '多支付渠道、订单状态机、资金安全',
    readTime: '5 分钟',
    content: `
      <h2>能收钱的网站，才是完整的网站</h2>
      <p>在线课程需要付费、电商需要支付、会员需要缴费——NCB 正在构建内置支付系统。</p>

      <h2>支付架构</h2>
      <p><strong>支付渠道</strong> — 项目级配置，填入商户号和密钥即可。NCB 封装不同平台的接口差异。</p>
      <p><strong>订单状态机</strong> — 待支付 → 支付中 → 已支付 → 已完成。超时自动取消，异常状态人工处理。</p>

      <h2>支付渠道路线图</h2>
      <p><strong>第一阶段</strong>：微信支付、支付宝</p>
      <p><strong>第二阶段</strong>：银联云闪付、Apple Pay</p>
      <p><strong>第三阶段</strong>：PayPal、Stripe（跨境支付）</p>

      <h2>三步接入</h2>
      <p>配置渠道 → 设计支付按钮 → 发布。不需要理解 OAuth 签名、回调验证。</p>

      <h2>资金安全</h2>
      <p>金额以「分」存储（BIGINT），状态机严格约束，幂等回调，超时清理，完整操作日志。</p>
    `
  },
  {
    id: 12,
    slug: 'admin-dashboard',
    icon: '📈',
    title: '内嵌管理后台：运营网站的控制中心',
    subtitle: '用户管理、内容管理、运营分析、热力图',
    readTime: '6 分钟',
    content: `
      <h2>建好网站只是开始</h2>
      <p>大多数 AI 建站工具和模板建站帮你把网站搭起来，但没有管理后台。NCB 的答案是：每个网站自带完整管理后台。</p>

      <h2>已上线：用户管理</h2>
      <p>用户列表、详情、角色分配、封禁——开启用户认证后自动具备。</p>

      <h2>开发中：内容管理后台</h2>
      <p>文章管理、分类管理、编辑→预览→上架工作流、SEO 优化、多人协作。</p>

      <h2>规划中：运营分析</h2>
      <p><strong>访问统计</strong> — PV/UV 趋势，了解流量规模。</p>
      <p><strong>页面分析</strong> — 页面访问量、停留时长、跳出率。</p>
      <p><strong>IP 与地域</strong> — 地图可视化用户地域分布。</p>
      <p><strong>热力图</strong> — 页面点击密度可视化，发现用户行为。</p>
      <p><strong>实时监控</strong> — 当前在线用户数和页面浏览。</p>
      <p><strong>数据报表</strong> — 自定义报表、Excel 导出。</p>

      <h2>为什么内嵌很重要？</h2>
      <p><strong>一体化</strong>：设计、管理、分析全在一个平台。</p>
      <p><strong>数据打通</strong>：流量→注册→订单的全链路分析。</p>
      <p><strong>隐私合规</strong>：数据不发送到第三方。</p>
    `
  }
];
